/**
 * Temporary UI killswitch for guest harbor actions.
 * Set to false to re-enable Top-Up, Request to Dock, and Apply for Permit.
 */
export const HARBOR_ACTIONS_TEMP_DISABLED = false;
